export class RubroRequest {
    public codEstadoConvenio: string = '-1';
    public idUser: string = '-1';
}
